module.exports = __webpack_public_path__ + "static/fluent-tag-picker-a7c0bd4d1db61ba5a8e1d6361d9a9c28.png";